import AnimatedLink from '@moncler/components/routerTransitions/AnimatedLink';
import analytics from '@utils/analytics';
import React, { useContext } from 'react';
import { __RouterContext } from 'react-router';
const ProductLink = (props) => {
    const router = useContext(__RouterContext) && (navigator.userAgent || '').indexOf('bot') === -1;
    const linkProps = {
        productId: props.product.id,
        to: props.product.route,
        className: props.className,
        from: {
            state: {
                thumbStartIndex: props.index,
            },
        },
    };
    const onClickAction = (event) => {
        var _a, _b;
        if (props.noClickTracking) {
            return;
        }
        if (props.pageType == 'curator-plp') {
            sessionStorage.setItem('from-curator-plp', window.history.length.toString());
            // [OE-21429]
            analytics.shopTheLookPdp(props === null || props === void 0 ? void 0 : props.product, props === null || props === void 0 ? void 0 : props.index, props === null || props === void 0 ? void 0 : props.actionList);
        }
        switch (props.linktype) {
            case 'LOOKPRODUCT':
                analytics.shopTheLookPdp(props.product, props.index, props.actionList);
                window.scrollTo(0, 0);
                break;
            case 'RECS':
                if (event.currentTarget.closest('[data-slot="recommendations-recentlyviewed"]')) {
                    analytics.recommendedTile(props.product, `recommended_${props.pageType || 'pdp'}_recently`, props.index);
                }
                else if (event.currentTarget.closest('[data-slot="recommendations-profile"]')) {
                    analytics.recommendedTile(props.product, `recommended_${props.pageType || 'pdp'}_profile`, props.index);
                }
                else if (props.actionList) {
                    analytics.shopTheLookPdp(props.product, props.index, props.actionList);
                }
                else {
                    analytics.recommendedTile(props.product, `recommended_${props.pageType || 'pdp'}${props.pageType == 'search' ? '_no_results' : (props === null || props === void 0 ? void 0 : props.recommender) ? '_' + props.recommender : ''}`, props.index);
                }
                break;
            case 'PLP':
                if (props.isTechnicalPage) {
                    analytics.productClickTP(props.product, props.index, `${props === null || props === void 0 ? void 0 : props.region.toLowerCase()}_grenoble_tp_${props.analyticsSuffix ? props.analyticsSuffix : props.product.analyticsAttributes.dimension38.toLowerCase()}`);
                }
                else {
                    analytics.productClick(props.product, props.index, props.isShelf);
                }
                break;
            case 'SEARCH':
                const query = (_a = new URLSearchParams(location.search)) === null || _a === void 0 ? void 0 : _a.get('query');
                analytics.productSearchClickGeneric(props.product.id, query);
                analytics.productSearchClick(props.product, props.index);
                ((_b = props.product) === null || _b === void 0 ? void 0 : _b.VTOcode) && analytics.vtoSearchGeneric(props.product.id);
            default:
                break;
        }
    };
    return router ? (React.createElement(AnimatedLink, Object.assign({ product: props.product }, linkProps, { trackingAction: onClickAction, ariaLabel: props.ariaLabel, ariaHidden: props.ariaHidden, tabIndex: props.tabIndex, originalUuid: props.originalUuid, id: props.product.id + '_link' }), props.children)) : (React.createElement("a", { href: props.product.productUrl, onClick: onClickAction, className: props.className, "aria-label": props.ariaLabel, "aria-hidden": props.ariaHidden, tabIndex: props.tabIndex }, props.children));
};
export default ProductLink;
